import { Observable } from 'rxjs';
import { ReadOptions } from '@app/domain/models/read-options.model';
import { TpvBusinessUnit } from '@app/domain/models/tpv/business-unit.model';
import { TpvListQuery, TpvPage } from '@app/domain/models/tpv/tpv-page.model';

export interface BusinessUnitListQuery extends TpvListQuery {
  companyName?: string;
  idCompany?: string;
  idUnit?: string;
  entity?: string;
  /** Estado(s) a incluir: `ACTIVO` / `INACTIVO` / `ELIMINADO`. Se envía como CSV. */
  status?: string[];
  /**
   * Búsqueda server-side (contrato 2026-09-29): el micro TPV hace OR entre las
   * columnas visibles del directorio de unidades — nombre, razón social, empresa
   * y RFC. Sustituye al mapeo local por `merchantName → ?name=`, que solo miraba
   * el nombre y descartaba una UdN cuyo RFC coincidía pero cuyo nombre no.
   */
  search?: string;
}

/**
 * Port de lectura del directorio de unidades de negocio.
 * `id_unit` es OPCIONAL aquí (filtro), a diferencia de las demás lecturas.
 *
 * `options` (`ReadOptions`, dato PURO de dominio) va como SEGUNDO parámetro y
 * nunca dentro del query: el query se serializa a parámetros de URL en
 * `toHttpParams`, y una opción de transporte metida ahí acabaría viajando como
 * `?silent=true` al backend. Son dos cosas distintas y se mantienen separadas.
 */
export abstract class BusinessUnitDirectoryRepository {
  abstract getBusinessUnits(
    query?: BusinessUnitListQuery,
    options?: ReadOptions,
  ): Observable<TpvPage<TpvBusinessUnit>>;
}
